export class ApplicationContactsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async bulkUpdate({ applicationId, ...body }) {
    return this.#http.put(`/applications/${applicationId}/contacts/bulk-update`, body);
  }
}
